<template>
  <div id="app">
    <v-fab-transition>
      <v-btn
        color="error"
        fab
        large
        dark
        class="v-btn--open-dialog"
        @click="parametersDialog = !parametersDialog"
        style="z-index: 100"
      >
        <v-icon v-if="!parametersDialog">keyboard_arrow_right</v-icon>
        <v-icon v-if="parametersDialog">keyboard_arrow_left</v-icon>
      </v-btn>
    </v-fab-transition>

    <v-dialog v-model="parametersDialog" max-width="600px">
      <v-card class="mx-auto" max-width="1000">
        <v-card-text>
          <v-form ref="form">
            <v-row>
              <v-col cols="12" sm="6">
                <v-icon
                  class="float-left py-4 pr-2 d-none d-sm-flex"
                  color="primary"
                  >person</v-icon
                >
                <v-text-field
                  v-model="firstname"
                  label="First name"
                ></v-text-field>
              </v-col>

              <v-col cols="12" sm="6">
                <v-text-field
                  v-model="lastname"
                  label="Last name"
                ></v-text-field>
              </v-col>
            </v-row>

            <v-row>
              <v-col cols="12" md="12">
                <v-icon
                  class="float-left py-4 pr-2 d-none d-sm-flex"
                  color="primary"
                  >email</v-icon
                >
                <v-text-field v-model="email" label="Email"></v-text-field>
              </v-col>
            </v-row>

            <v-row>
              <v-col cols="12" md="12">
                <v-icon
                  class="float-left py-4 pr-2 d-none d-sm-flex"
                  color="primary"
                  >settings_cell</v-icon
                >
                <v-text-field
                  v-model="mobile"
                  label="Mobile number"
                  v-mask="'##############'"
                ></v-text-field>
              </v-col>
            </v-row>

            <v-card-actions>
              <v-btn
                @click="parametersDialog = !parametersDialog"
                color="red"
                dark
                >Close</v-btn
              >
              <div class="flex-grow-1"></div>
              <v-btn @click="bookingSearch()" color="info">Search</v-btn>
            </v-card-actions>
          </v-form>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-container>
      <Header />
      <v-overlay :value="loader">
        <v-progress-circular indeterminate size="64"></v-progress-circular>
      </v-overlay>
      <div class="text-center">
        <v-btn
          class="my-2 text-center"
          fab
          dark
          large
          color="blue darken-3"
          @click="previous"
        >
          <v-icon dark> keyboard_arrow_up </v-icon>
        </v-btn>
      </div>

      <BookingComponent :eventData="events" v-if="events.length > 0" />
      <div class="text-center">
        <v-btn
          class="my-2 text-center"
          fab
          dark
          large
          color="blue darken-3"
          @click="next"
        >
          <v-icon dark> keyboard_arrow_down </v-icon>
        </v-btn>
      </div>
    </v-container>
  </div>
</template>

<script>
import Header from "../components/Header.vue";
import BookingComponent from "../components/Booking.vue";
import moment from "moment";
import { Event } from "../classes/Event";
import { Booking } from "../classes/Booking";

export default {
  components: {
    Header,
    BookingComponent
  },
  data() {
    return {
      loader: false,
      events: [],
      nextToken: null,
      from: moment().subtract(1, "day"),
      to: moment().add(3, "month"),
      parametersDialog: false,
      firstname: null,
      lastname: null,
      email: null,
      dob: null,
      mobile: null
    };
  },
  created() {
    this.getEvents();
  },
  methods: {
    async getEvents() {
      this.loader = true;
      this.events = [];
      this.nextToken = null;
      let nextEvents = await new Event().getEventsByDateRange({
        from: this.from,
        to: this.to,
        nextToken: this.nextToken
      });
      let events = nextEvents.items;
      this.nextToken = nextEvents.nextToken;
      while (this.nextToken !== null) {
        nextEvents = await new Event().getEventsByDateRange({
          from: this.from,
          to: this.to,
          nextToken: this.nextToken
        });
        events.push(...nextEvents.items);
        this.nextToken = nextEvents.nextToken;
      }
      this.events = events;
      this.loader = false;
    },
    async previous() {
      (this.from = this.from.subtract(3, "month")),
        (this.to = this.to.subtract(3, "month")),
        this.getEvents();
    },
    async next() {
      (this.from = this.from.add(3, "month")),
        (this.to = this.to.add(3, "month")),
        this.getEvents();
    },
    async getEventById(id) {
      const events = await Booking.getEventById(id);
      return events;
    },
    async bookingSearch() {
      const that = this;
      this.parametersDialog = false;
      this.loader = true;
      this.events = [];
      if (this.firstname || this.lastname || this.email || this.mobile) {
        let eventIds = [];
        // Firstname, lastname and email (perfect search)
        if (this.firstname && this.lastname && this.email) {
          // console.log(`${this.firstname} ${this.lastname} ${this.email}`);
          let e = await this.searchBookingBySearchField(
            `${this.firstname} ${this.lastname} ${this.email}`
          );
          eventIds.push(...e);
        } else if (this.firstname || this.lastname || this.email) {
          // Firstname and lastname
          if (this.firstname && this.lastname) {
            // console.log(`${this.firstname} ${this.lastname} both`);
            var filter = {
              firstname: { eq: this.firstname },
              lastname: { eq: this.lastname }
            };
            let e = await this.searchBooking(filter);
            eventIds.push(...e);
          } else {
            // Firstname only
            if (this.firstname && !this.lastname) {
              // console.log(`${this.firstname} firstname`);
              var filter = {
                firstname: { eq: this.firstname }
              };
              let e = await this.searchBooking(filter);
              eventIds.push(...e);
            }
            // Lastname only
            if (!this.firstname && this.lastname) {
              // console.log(`${this.lastname} lastname`);
              var filter = {
                lastname: { eq: this.lastname }
              };
              let e = await this.searchBooking(filter);
              eventIds.push(...e);
            }
          }
          // Email
          if (this.email) {
            // console.log(`${this.email} email`);
            var filter = {
              email: { eq: this.email }
            };
            let e = await this.searchBooking(filter);
            eventIds.push(...e);
          }
        }
        // Mobile
        if (this.mobile) {
          // console.log(`${this.mobile} phone`);
          var filter = {
            mobile: { eq: this.mobile }
          };
          let e = await this.searchBooking(filter);
          eventIds.push(...e);
        }
        eventIds = [...new Set(eventIds)];

        var getEventById = id => {
          return new Promise((resolve, reject) => {
            resolve(that.getEventById(id));
          });
        };

        var promises = eventIds.map(async id => {
          var result = await getEventById(id);
          return new Promise((res, rej) => {
            res(result);
          });
        });

        Promise.all(promises).then(results => {
          // do what you want on the results
          that.events = results;
        });
      }
      this.loader = false;
    },
    async searchBookingBySearchField(searchQuery) {
      this.nextToken = null;
      let nextEvents = await this.nextSearchBookingBySearchField(searchQuery);
      while (this.nextToken !== null) {
        let nextEvents = await this.nextSearchBookingBySearchField(searchQuery);
        nextEvents.push(...nextEvents);
      }
      return nextEvents;
    },
    async nextSearchBookingBySearchField(searchQuery) {
      const events = await Booking.searchBookingBySearchField({
        searchQuery,
        nextToken: this.nextToken
      });

      this.nextToken = events.nextToken;
      const eventIds = events.items.map(
        event => event.eventSlot.eventSlotGroup.eventLocation.event.id
      );
      return eventIds;
    },
    async searchBooking(filter) {
      this.nextToken = null;
      let nextEvents;
      nextEvents = await this.nextSearchBooking(filter);
      while (this.nextToken !== null) {
        let e = await this.nextSearchBooking(filter);
        nextEvents.push(...e);
      }
      return nextEvents;
    },
    async nextSearchBooking(filter) {
      const events = await Booking.searchBookingByField({
        filter: filter,
        nextToken: this.nextToken
      });
      this.nextToken = events.nextToken;
      const eventIds = events.items.map(
        event => event.eventSlot.eventSlotGroup.eventLocation.event.id
      );
      return eventIds;
    }
  }
};
</script>
<style scoped>
.v-btn--open-dialog {
  top: 90px;
  position: fixed;
  margin: 0 0 16px 16px;
}
</style>
